// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-modal-custom {
  width: 12rem;
  border-radius: 2px;
  box-shadow: 1px 1px 16px 10px rgba(136, 136, 136, 0.3333333333);
}
.profile-modal-custom img {
  width: 100%;
  height: 10rem;
  border-radius: 2px 2px 0px 0;
}
.profile-modal-custom_details {
  padding: 15px 10px 2rem 10px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/App/Styles/profile-modal.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,+DAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,4BAAA;AACJ;AAEE;EACE,4BAAA;AAAJ","sourcesContent":[".profile-modal-custom {\n  width: 12rem;\n  border-radius: 2px;\n  box-shadow: 1px 1px 16px 10px #8885;\n\n  img {\n    width: 100%;\n    height: 10rem;\n    border-radius: 2px 2px 0px 0;\n  }\n\n  &_details {\n    padding: 15px 10px 2rem 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
